import { useState } from "react";
import { AmbientGlow } from "./_shared";

// Ported from Claude Design handoff (sections-rest: ProductPreview).
// Browser chrome with traffic dots + tab bar + real screenshots.
// All 4 screenshots are rendered stacked and pre-loaded, with opacity
// cross-fade on tab change — avoids the flash/lag from keyed remounts.

const V = "3";
const TABS = [
  { id: "overview", label: "Overview", image: `/screenshots/dashboard-overview.png?v=${V}` },
  { id: "alerts", label: "Alertas", image: `/screenshots/dashboard-alerts.png?v=${V}` },
  { id: "ai", label: "IA", image: `/screenshots/dashboard-ai.png?v=${V}` },
  { id: "cve", label: "CVE", image: `/screenshots/dashboard-cve.png?v=${V}` },
] as const;

export function ProductPreview() {
  const [tab, setTab] = useState(0);

  return (
    <section
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tl-br" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1120,
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontFamily: "var(--cy-fs-sans)",
            fontSize: "clamp(36px, 4.5vw, 52px)",
            lineHeight: 1.05,
            letterSpacing: "-0.03em",
            fontWeight: 500,
            margin: "0 0 48px",
            color: "var(--cy-ink-100)",
          }}
        >
          Veja o Cyphron em ação
        </h2>

        <div
          style={{
            border: "1px solid var(--cy-ink-10)",
            borderRadius: 10,
            overflow: "hidden",
            background: "var(--cy-bg-elev)",
            boxShadow: "0 30px 80px -30px rgba(0,0,0,0.7)",
          }}
        >
          {/* Browser chrome */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 14px",
              background: "var(--cy-bg-elev-2)",
              borderBottom: "1px solid var(--cy-ink-10)",
            }}
          >
            <div style={{ display: "flex", gap: 6 }}>
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: "50%",
                  background: "var(--cy-ink-20)",
                }}
              />
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: "50%",
                  background: "var(--cy-ink-20)",
                }}
              />
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: "50%",
                  background: "var(--cy-ink-20)",
                }}
              />
            </div>
            <div
              className="cy-mono"
              style={{
                flex: 1,
                textAlign: "center",
                background: "var(--cy-bg)",
                borderRadius: 6,
                padding: "5px 10px",
                fontSize: 11.5,
                color: "var(--cy-ink-60)",
              }}
            >
              cyphron.com.br/dashboard
            </div>
          </div>

          {/* Tab bar */}
          <div
            style={{
              display: "flex",
              gap: 0,
              padding: "0 14px",
              borderBottom: "1px solid var(--cy-ink-10)",
            }}
          >
            {TABS.map((t, i) => (
              <button
                key={t.id}
                onClick={() => setTab(i)}
                style={{
                  padding: "12px 18px",
                  background: "transparent",
                  border: "none",
                  color:
                    tab === i ? "var(--cy-ink-100)" : "var(--cy-ink-60)",
                  fontFamily: "var(--cy-fs-sans)",
                  fontSize: 13,
                  borderBottom:
                    tab === i
                      ? "2px solid var(--cy-accent)"
                      : "2px solid transparent",
                  cursor: "pointer",
                  transition: "color .15s ease",
                  marginBottom: -1,
                }}
              >
                {t.label}
              </button>
            ))}
          </div>

          {/* Stacked screenshots — smooth cross-fade via opacity.
              Uses the first image to establish the intrinsic aspect ratio;
              the rest are absolutely positioned on top. */}
          <div
            style={{
              position: "relative",
              background: "var(--cy-bg)",
            }}
          >
            {TABS.map((t, i) => (
              <img
                key={t.id}
                src={t.image}
                alt={`Dashboard — ${t.label}`}
                loading={i === 0 ? "eager" : "lazy"}
                style={{
                  display: "block",
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  position: i === 0 ? "relative" : "absolute",
                  top: 0,
                  left: 0,
                  opacity: tab === i ? 1 : 0,
                  transition:
                    "opacity 280ms cubic-bezier(0.22, 1, 0.36, 1)",
                  pointerEvents: tab === i ? "auto" : "none",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
